import { AppBar } from "./Vertical/AppBar";
import { HorizontalBar } from "./Horizontal/AppBar";
import { LayoutProps } from "./@types/LayoutsTypes";
import { useMediaQuery } from "@mantine/hooks";
import { useRouter } from "next/router";
import { useSession } from "next-auth/react";
import { useState } from "react";

export const Layout = ({ children, title }: LayoutProps) => {
  const router = useRouter();
  const matches = useMediaQuery("(max-width: 600px)", false);

  const [toggleSideBar, setToggleSideBar] = useState(matches ? true : false);

  const toggleAppBar = () => {
    toggleSideBar ? setToggleSideBar(false) : setToggleSideBar(true);
  };

  const { data: session } = useSession();

  return (
    <div id="Layout">
      <AppBar props={{ state: toggleSideBar, session }} />

      <div id="LayoutContainer">
        <HorizontalBar
          props={{
            title,
            path: router.pathname.split("/"),
            state: toggleSideBar,
            callBack: toggleAppBar,
          }}
        />
        {children}
      </div>
    </div>
  );
};
